import { Grid, Paper } from '@material-ui/core';
import React from 'react';
import { DateCell, NumberCell } from '../../../../utils/Cells';

export function GridItem({ value, label, type }) {

    const getValue = () => {
        let result;
        if ('date' === type) {
            result = <DateCell value={value} />
        } else if ('amount' === type) {
            result = <NumberCell value={value} />
        } else {
            result = value
        }
        return result;
    }

    return (
        <Grid item xs={3}>
            <Paper className='grid-item-paper'>
                <div className='grid-item'>
                    <h4> {label}: </h4 >
                    <span>{getValue()}</span>
                </div>
            </Paper>
        </Grid >
    )
}